<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>南通侧</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">温湿度</div>
          <div class="sensor2">温湿度</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机组</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">南通</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">江侧</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-left" content="南通侧除湿机1/2" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/sutong/nantong/dehumidifierSmall"></router-link>
          </el-tooltip>
          <el-tooltip class="station-block station-block-right" content="南通侧除湿机3/4" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/sutong/nantong/dehumidifierBig"></router-link>
          </el-tooltip>

          <div class="stati sta-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "除湿机1",
                    nantongStationHumidityTooltipError1,
                    nantongStationHumidityAllowedMax1,
                    nantongStationRunning1,
                    nantongStationMalfunction1
                  )
                }}
                <br />
                {{
                  assembleTooltip_dehumidifier(
                    "除湿机2",
                    nantongStationHumidityTooltipError2,
                    nantongStationHumidityAllowedMax2,
                    nantongStationRunning2,
                    nantongStationMalfunction2
                  )
                }}
              </div>
              <div :class="nantongStationError12" class="state-info right-pos">
                <p>NA18梁段除湿1/2</p>
                <p>
                  <span>{{ nantongStationHumidity1 | toFixed }}% {{ nantongStationTemperature1 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="nantongStationRunningTooltip1" effect="light" placement="right"> -->
                  <span :class="nantongStationRunningClass1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
                <p>
                  <span>{{ nantongStationHumidity2 | toFixed }}% {{ nantongStationTemperature2 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="nantongStationRunningTooltip2" effect="light" placement="right"> -->
                  <span :class="nantongStationRunningClass2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <!-- <div class="stati sta-left-vent" v-if="false">
            <div :class="nantongStationErrorVent" class="state-info left-pos">
              <p>NA18梁段排风</p>
              <p>{{nantongStationHumidityVent | toFixed}}%</p>
              <p>{{nantongStationTemperatureVent | toFixed}}°C</p>
            </div>
          </div>-->
          <div class="stati sta-right-nantong">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "除湿机1",
                    nantongStationHumidityTooltipError3,
                    nantongStationHumidityAllowedMax3,
                    nantongStationRunning3,
                    nantongStationMalfunction3
                  )
                }}
                <br />
                {{
                  assembleTooltip_dehumidifier(
                    "除湿机2",
                    nantongStationHumidityTooltipError4,
                    nantongStationHumidityAllowedMax4,
                    nantongStationRunning4,
                    nantongStationMalfunction4
                  )
                }}
              </div>
              <div :class="nantongStationError34" class="state-info left-pos">
                <p>NJ16梁段除湿3/4</p>
                <p>
                  <span>{{ nantongStationHumidity3 | toFixed }}% {{ nantongStationTemperature3 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="nantongStationRunningTooltip3" effect="light" placement="right"> -->
                  <span :class="nantongStationRunningClass3" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
                <p>
                  <span>{{ nantongStationHumidity4 | toFixed }}% {{ nantongStationTemperature4 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="nantongStationRunningTooltip4" effect="light" placement="right"> -->
                  <span :class="nantongStationRunningClass4" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-right-fresh-air">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "新风1",
                    nantongStationHumidityTooltipErrorFreshAir1,
                    nantongStationHumidityAllowedMaxFreshAir1,
                    nantongStationRunningFreshAir1,
                    nantongStationMalfunctionFreshAir1
                  )
                }}
                <br />
                {{
                  assembleTooltip_dehumidifier(
                    "新风2",
                    nantongStationHumidityTooltipErrorFreshAir2,
                    nantongStationHumidityAllowedMaxFreshAir2,
                    nantongStationRunningFreshAir2,
                    nantongStationMalfunctionFreshAir2
                  )
                }}
              </div>
              <div :class="nantongStationErrorFreshAir12" class="state-info right-pos">
                <p>NJ16梁段新风1/2</p>
                <p>
                  <span>{{ nantongStationHumidityFreshAir1 | toFixed }}% {{ nantongStationTemperatureFreshAir1 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="nantongStationRunningTooltipFreshAir1" effect="light" placement="right"> -->
                  <span :class="nantongStationRunningClassFreshAir1" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
                <p>
                  <span>{{ nantongStationHumidityFreshAir2 | toFixed }}% {{ nantongStationTemperatureFreshAir2 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="nantongStationRunningTooltipFreshAir2" effect="light" placement="right"> -->
                  <span :class="nantongStationRunningClassFreshAir2" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 left1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", nantongHumidityTooltipError1, nantongHumidityAllowedMax1) }}
              </div>
              <div :class="nantongError1" class="state-info right-pos">
                <p>NA30梁段</p>
                <p>{{ nantongHumidity1 | toFixed }}%</p>
                <p>{{ nantongTemperature1 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 left2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", nantongHumidityTooltipError2, nantongHumidityAllowedMax2) }}
              </div>
              <div :class="nantongError2" class="state-info right-pos">
                <p>NA21梁段</p>
                <p>{{ nantongHumidity2 | toFixed }}%</p>
                <p>{{ nantongTemperature2 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 left3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", nantongHumidityTooltipError3, nantongHumidityAllowedMax3) }}
              </div>
              <div :class="nantongError3" class="state-info right-pos">
                <p>NA15梁段</p>
                <p>{{ nantongHumidity3 | toFixed }}%</p>
                <p>{{ nantongTemperature3 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 left4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", nantongHumidityTooltipError4, nantongHumidityAllowedMax4) }}
              </div>
              <div :class="nantongError4" class="state-info right-pos">
                <p>NA8梁段</p>
                <p>{{ nantongHumidity4 | toFixed }}%</p>
                <p>{{ nantongTemperature4 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 middle-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", nantongHumidityTooltipError5, nantongHumidityAllowedMax5) }}
              </div>
              <div :class="nantongError5" class="state-info right-pos">
                <p>NT0梁段</p>
                <p>{{ nantongHumidity5 | toFixed }}%</p>
                <p>{{ nantongTemperature5 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 right4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", nantongHumidityTooltipError6, nantongHumidityAllowedMax6) }}
              </div>
              <div :class="nantongError6" class="state-info left-pos">
                <p>NJ8梁段</p>
                <p>{{ nantongHumidity6 | toFixed }}%</p>
                <p>{{ nantongTemperature6 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 right3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", nantongHumidityTooltipError7, nantongHumidityAllowedMax7) }}
              </div>
              <div :class="nantongError7" class="state-info left-pos">
                <p>NJ15梁段</p>
                <p>{{ nantongHumidity7 | toFixed }}%</p>
                <p>{{ nantongTemperature7 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 right2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", nantongHumidityTooltipError8, nantongHumidityAllowedMax8) }}
              </div>
              <div :class="nantongError8" class="state-info left-pos">
                <p>NJ21梁段</p>
                <p>{{ nantongHumidity8 | toFixed }}%</p>
                <p>{{ nantongTemperature8 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 right1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", nantongHumidityTooltipError9, nantongHumidityAllowedMax9) }}
              </div>
              <div :class="nantongError9" class="state-info left-pos">
                <p>NJ28梁段</p>
                <p>{{ nantongHumidity9 | toFixed }}%</p>
                <p>{{ nantongTemperature9 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>常熟侧</h2>
      </div>
      <div class="cable-main">
        <div class="legend">
          <div class="sensor1">温湿度</div>
          <div class="sensor2">温湿度</div>
        </div>
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>除湿机组</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">江侧</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">常熟</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-left" content="常熟侧除湿机1/2" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/sutong/nantong/dehumidifierSmall"></router-link>
          </el-tooltip>
          <el-tooltip class="station-block station-block-right" content="常熟侧除湿机3/4" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/sutong/nantong/dehumidifierBig"></router-link>
          </el-tooltip>

          <div class="stati sta-left">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "除湿机5",
                    changshuStationHumidityTooltipError5,
                    changshuStationHumidityAllowedMax5,
                    changshuStationRunning5,
                    changshuStationMalfunction5
                  )
                }}
                <br />
                {{
                  assembleTooltip_dehumidifier(
                    "除湿机6",
                    changshuStationHumidityTooltipError6,
                    changshuStationHumidityAllowedMax6,
                    changshuStationRunning6,
                    changshuStationMalfunction6
                  )
                }}
              </div>
              <div :class="changshuStationError56" class="state-info right-pos">
                <p>SJ16梁段除湿5/6</p>
                <p>
                  <span>{{ changshuStationHumidity5 | toFixed }}% {{ changshuStationTemperature5 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="changshuStationRunningTooltip5" effect="light" placement="right"> -->
                  <span :class="changshuStationRunningClass5" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
                <p>
                  <span>{{ changshuStationHumidity6 | toFixed }}% {{ changshuStationTemperature6 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="changshuStationRunningTooltip6" effect="light" placement="right"> -->
                  <span :class="changshuStationRunningClass6" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <div class="stati sta-left-fresh-air">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "新风3",
                    changshuStationHumidityTooltipErrorFreshAir3,
                    changshuStationHumidityAllowedMaxFreshAir3,
                    changshuStationRunningFreshAir3,
                    changshuStationMalfunctionFreshAir3
                  )
                }}
                <br />
                {{
                  assembleTooltip_dehumidifier(
                    "新风4",
                    changshuStationHumidityTooltipErrorFreshAir4,
                    changshuStationHumidityAllowedMaxFreshAir4,
                    changshuStationRunningFreshAir4,
                    changshuStationMalfunctionFreshAir4
                  )
                }}
              </div>
              <div :class="changshuStationErrorFreshAir34" class="state-info left-pos">
                <p>SJ16梁段新风3/4</p>
                <p>
                  <span>{{ changshuStationHumidityFreshAir3 | toFixed }}% {{ changshuStationTemperatureFreshAir3 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="changshuStationRunningTooltipFreshAir3" effect="light" placement="right"> -->
                  <span :class="changshuStationRunningClassFreshAir3" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
                <p>
                  <span>{{ changshuStationHumidityFreshAir4 | toFixed }}% {{ changshuStationTemperatureFreshAir4 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="changshuStationRunningTooltipFreshAir4" effect="light" placement="right"> -->
                  <span :class="changshuStationRunningClassFreshAir4" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>
          <!-- <div class="stati sta-right-vent" v-if="false">
            <div :class="changshuStationErrorVent" class="state-info right-pos">
              <p>SA18梁段排风</p>
              <p>{{changshuStationHumidityVent | toFixed}}%</p>
              <p>{{changshuStationTemperatureVent | toFixed}}°C</p>
            </div>
          </div>-->
          <div class="stati sta-right-changshu">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "除湿机7",
                    changshuStationHumidityTooltipError7,
                    changshuStationHumidityAllowedMax7,
                    changshuStationRunning7,
                    changshuStationMalfunction7
                  )
                }}
                <br />
                {{
                  assembleTooltip_dehumidifier(
                    "除湿机8",
                    changshuStationHumidityTooltipError8,
                    changshuStationHumidityAllowedMax8,
                    changshuStationRunning8,
                    changshuStationMalfunction8
                  )
                }}
              </div>
              <div :class="changshuStationError78" class="state-info left-pos">
                <p>SA18梁段除湿7/8</p>
                <p>
                  <span>{{ changshuStationHumidity7 | toFixed }}% {{ changshuStationTemperature7 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="changshuStationRunningTooltip7" effect="light" placement="right"> -->
                  <span :class="changshuStationRunningClass7" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
                <p>
                  <span>{{ changshuStationHumidity8 | toFixed }}% {{ changshuStationTemperature8 | toFixed }}°C</span>
                  <!-- <el-tooltip :content="changshuStationRunningTooltip8" effect="light" placement="right"> -->
                  <span :class="changshuStationRunningClass8" class="valve-sign"></span>
                  <!-- </el-tooltip> -->
                </p>
              </div>
            </el-tooltip>
          </div>

          <div class="clip sensor1 left1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", changshuHumidityTooltipError9, changshuHumidityAllowedMax9) }}
              </div>
              <div :class="changshuError9" class="state-info right-pos">
                <p>SJ28梁段</p>
                <p>{{ changshuHumidity9 | toFixed }}%</p>
                <p>{{ changshuTemperature9 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 left2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", changshuHumidityTooltipError8, changshuHumidityAllowedMax8) }}
              </div>
              <div :class="changshuError8" class="state-info right-pos">
                <p>SJ21梁段</p>
                <p>{{ changshuHumidity8 | toFixed }}%</p>
                <p>{{ changshuTemperature8 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 left3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", changshuHumidityTooltipError7, changshuHumidityAllowedMax7) }}
              </div>
              <div :class="changshuError7" class="state-info right-pos">
                <p>SJ15梁段</p>
                <p>{{ changshuHumidity7 | toFixed }}%</p>
                <p>{{ changshuTemperature7 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 left4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", changshuHumidityTooltipError6, changshuHumidityAllowedMax6) }}
              </div>
              <div :class="changshuError6" class="state-info right-pos">
                <p>SJ8梁段</p>
                <p>{{ changshuHumidity6 | toFixed }}%</p>
                <p>{{ changshuTemperature6 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 middle-right">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", changshuHumidityTooltipError5, changshuHumidityAllowedMax5) }}
              </div>
              <div :class="changshuError5" class="state-info left-pos">
                <p>ST0梁段</p>
                <p>{{ changshuHumidity5 | toFixed }}%</p>
                <p>{{ changshuTemperature5 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 right4">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", changshuHumidityTooltipError4, changshuHumidityAllowedMax4) }}
              </div>
              <div :class="changshuError4" class="state-info left-pos">
                <p>SA8梁段</p>
                <p>{{ changshuHumidity4 | toFixed }}%</p>
                <p>{{ changshuTemperature4 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 right3">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", changshuHumidityTooltipError3, changshuHumidityAllowedMax3) }}
              </div>
              <div :class="changshuError3" class="state-info left-pos">
                <p>SA15梁段</p>
                <p>{{ changshuHumidity3 | toFixed }}%</p>
                <p>{{ changshuTemperature3 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor1 right2">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", changshuHumidityTooltipError2, changshuHumidityAllowedMax2) }}
              </div>
              <div :class="changshuError2" class="state-info left-pos">
                <p>SA21梁段</p>
                <p>{{ changshuHumidity2 | toFixed }}%</p>
                <p>{{ changshuTemperature2 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
          <div class="clip sensor2 right1">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{ assembleTooltip_sensor("", changshuHumidityTooltipError1, changshuHumidityAllowedMax1) }}
              </div>
              <div :class="changshuError1" class="state-info left-pos">
                <p>SA30梁段</p>
                <p>{{ changshuHumidity1 | toFixed }}%</p>
                <p>{{ changshuTemperature1 | toFixed }}°C</p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,
      nantongStationHumidity1: "--",
      nantongStationHumidity2: "--",
      nantongStationHumidity3: "--",
      nantongStationHumidity4: "--",
      nantongStationTemperature1: "--",
      nantongStationTemperature2: "--",
      nantongStationTemperature3: "--",
      nantongStationTemperature4: "--",
      nantongStationRunning1: "--",
      nantongStationRunning2: "--",
      nantongStationRunning3: "--",
      nantongStationRunning4: "--",
      nantongStationRunningFreshAir1: "--",
      nantongStationRunningFreshAir2: "--",
      nantongStationHumidityFreshAir1: "--",
      nantongStationHumidityFreshAir2: "--",
      nantongStationTemperatureFreshAir1: "--",
      nantongStationTemperatureFreshAir2: "--",
      nantongStationHumidityVent: "--",
      nantongStationTemperatureVent: "--",
      // nantongStationRunningTooltip1: "--",
      // nantongStationRunningTooltip2: "--",
      // nantongStationRunningTooltip3: "--",
      // nantongStationRunningTooltip4: "--",
      // nantongStationRunningTooltipFreshAir1: "--",
      // nantongStationRunningTooltipFreshAir2: "--",
      nantongStationRunningClass1: "",
      nantongStationRunningClass2: "",
      nantongStationRunningClass3: "",
      nantongStationRunningClass4: "",
      nantongStationRunningClassFreshAir1: "",
      nantongStationRunningClassFreshAir2: "",
      nantongHumidity1: "--",
      nantongHumidity2: "--",
      nantongHumidity3: "--",
      nantongHumidity4: "--",
      nantongHumidity5: "--",
      nantongHumidity6: "--",
      nantongHumidity7: "--",
      nantongHumidity8: "--",
      nantongHumidity9: "--",
      nantongTemperature1: "--",
      nantongTemperature2: "--",
      nantongTemperature3: "--",
      nantongTemperature4: "--",
      nantongTemperature5: "--",
      nantongTemperature6: "--",
      nantongTemperature7: "--",
      nantongTemperature8: "--",
      nantongTemperature9: "--",

      changshuStationHumidity5: "--",
      changshuStationHumidity6: "--",
      changshuStationHumidity7: "--",
      changshuStationHumidity8: "--",
      changshuStationTemperature5: "--",
      changshuStationTemperature6: "--",
      changshuStationTemperature7: "--",
      changshuStationTemperature8: "--",
      changshuStationRunning5: "--",
      changshuStationRunning6: "--",
      changshuStationRunning7: "--",
      changshuStationRunning8: "--",
      changshuStationRunningFreshAir3: "--",
      changshuStationRunningFreshAir4: "--",
      changshuStationHumidityFreshAir3: "--",
      changshuStationHumidityFreshAir4: "--",
      changshuStationTemperatureFreshAir3: "--",
      changshuStationTemperatureFreshAir4: "--",
      changshuStationHumidityVent: "--",
      changshuStationTemperatureVent: "--",
      // changshuStationRunningTooltip5: "--",
      // changshuStationRunningTooltip6: "--",
      // changshuStationRunningTooltip7: "--",
      // changshuStationRunningTooltip8: "--",
      // changshuStationRunningTooltipFreshAir3: "--",
      // changshuStationRunningTooltipFreshAir4: "--",
      changshuStationRunningClass5: "",
      changshuStationRunningClass6: "",
      changshuStationRunningClass7: "",
      changshuStationRunningClass8: "",
      changshuStationRunningClassFreshAir3: "",
      changshuStationRunningClassFreshAir4: "",
      changshuHumidity1: "--",
      changshuHumidity2: "--",
      changshuHumidity3: "--",
      changshuHumidity4: "--",
      changshuHumidity5: "--",
      changshuHumidity6: "--",
      changshuHumidity7: "--",
      changshuHumidity8: "--",
      changshuHumidity9: "--",
      changshuTemperature1: "--",
      changshuTemperature2: "--",
      changshuTemperature3: "--",
      changshuTemperature4: "--",
      changshuTemperature5: "--",
      changshuTemperature6: "--",
      changshuTemperature7: "--",
      changshuTemperature8: "--",
      changshuTemperature9: "--",

      nantongStationMalfunction1: "--",
      nantongStationMalfunction2: "--",
      nantongStationMalfunction3: "--",
      nantongStationMalfunction4: "--",
      nantongStationMalfunctionFreshAir1: "--",
      nantongStationMalfunctionFreshAir2: "--",
      changshuStationMalfunction5: "--",
      changshuStationMalfunction6: "--",
      changshuStationMalfunction7: "--",
      changshuStationMalfunction8: "--",
      changshuStationMalfunctionFreshAir3: "--",
      changshuStationMalfunctionFreshAir4: "--",

      nantongStationError12: "",
      nantongStationError34: "",
      nantongStationErrorFreshAir12: "",
      nantongStationErrorVent: "",
      nantongError1: "",
      nantongError2: "",
      nantongError3: "",
      nantongError4: "",
      nantongError5: "",
      nantongError6: "",
      nantongError7: "",
      nantongError8: "",
      nantongError9: "",

      changshuStationError56: "",
      changshuStationError78: "",
      changshuStationErrorFreshAir34: "",
      changshuStationErrorVent: "",
      changshuError1: "",
      changshuError2: "",
      changshuError3: "",
      changshuError4: "",
      changshuError5: "",
      changshuError6: "",
      changshuError7: "",
      changshuError8: "",
      changshuError9: "",

      //humidity allowed max
      nantongStationHumidityAllowedMax1: "--",
      nantongStationHumidityAllowedMax2: "--",
      nantongStationHumidityAllowedMax3: "--",
      nantongStationHumidityAllowedMax4: "--",
      nantongStationHumidityAllowedMaxFreshAir1: "--",
      nantongStationHumidityAllowedMaxFreshAir2: "--",
      nantongStationHumidityAllowedMaxVent: "--",
      nantongHumidityAllowedMax1: "--",
      nantongHumidityAllowedMax2: "--",
      nantongHumidityAllowedMax3: "--",
      nantongHumidityAllowedMax4: "--",
      nantongHumidityAllowedMax5: "--",
      nantongHumidityAllowedMax6: "--",
      nantongHumidityAllowedMax7: "--",
      nantongHumidityAllowedMax8: "--",
      nantongHumidityAllowedMax9: "--",
      changshuStationHumidityAllowedMax5: "--",
      changshuStationHumidityAllowedMax6: "--",
      changshuStationHumidityAllowedMax7: "--",
      changshuStationHumidityAllowedMax8: "--",
      changshuStationHumidityAllowedMaxFreshAir3: "--",
      changshuStationHumidityAllowedMaxFreshAir4: "--",
      changshuStationHumidityAllowedMaxVent: "--",
      changshuHumidityAllowedMax1: "--",
      changshuHumidityAllowedMax2: "--",
      changshuHumidityAllowedMax3: "--",
      changshuHumidityAllowedMax4: "--",
      changshuHumidityAllowedMax5: "--",
      changshuHumidityAllowedMax6: "--",
      changshuHumidityAllowedMax7: "--",
      changshuHumidityAllowedMax8: "--",
      changshuHumidityAllowedMax9: "--",

      //humidity tooltip error
      nantongStationHumidityTooltipError1: "--",
      nantongStationHumidityTooltipError2: "--",
      nantongStationHumidityTooltipError3: "--",
      nantongStationHumidityTooltipError4: "--",
      nantongStationHumidityTooltipErrorFreshAir1: "--",
      nantongStationHumidityTooltipErrorFreshAir2: "--",
      nantongStationHumidityTooltipErrorVent: "--",
      nantongHumidityTooltipError1: "--",
      nantongHumidityTooltipError2: "--",
      nantongHumidityTooltipError3: "--",
      nantongHumidityTooltipError4: "--",
      nantongHumidityTooltipError5: "--",
      nantongHumidityTooltipError6: "--",
      nantongHumidityTooltipError7: "--",
      nantongHumidityTooltipError8: "--",
      nantongHumidityTooltipError9: "--",
      changshuStationHumidityTooltipError5: "--",
      changshuStationHumidityTooltipError6: "--",
      changshuStationHumidityTooltipError7: "--",
      changshuStationHumidityTooltipError8: "--",
      changshuStationHumidityTooltipErrorFreshAir3: "--",
      changshuStationHumidityTooltipErrorFreshAir4: "--",
      changshuStationHumidityTooltipErrorVent: "--",
      changshuHumidityTooltipError1: "--",
      changshuHumidityTooltipError2: "--",
      changshuHumidityTooltipError3: "--",
      changshuHumidityTooltipError4: "--",
      changshuHumidityTooltipError5: "--",
      changshuHumidityTooltipError6: "--",
      changshuHumidityTooltipError7: "--",
      changshuHumidityTooltipError8: "--",
      changshuHumidityTooltipError9: "--",

      dataNameIdDict: {
        nantongStationHumidity1: "549ea385-5f5b-42d1-925c-c53b5f946bec",
        nantongStationHumidity2: "dbeda865-2853-4d58-87b0-13272d851ed0",
        nantongStationHumidity3: "ef211fd0-77be-41b6-999f-2c3b0949a71e",
        nantongStationHumidity4: "7b843655-8f8b-4313-ba76-f37f0d0b639e",
        nantongStationTemperature1: "fd706d62-9ca7-4dd3-8116-e34fc0400b78",
        nantongStationTemperature2: "f2fa8891-303c-4fe8-862b-d5bd922a27e2",
        nantongStationTemperature3: "85131d8e-f100-4966-af93-93d52ec38879",
        nantongStationTemperature4: "20c6a2fc-4b45-4285-8346-46285087e49c",
        nantongStationTemperatureFreshAir1: "3ddab142-1126-4f47-9f48-d06b442993f2",
        nantongStationTemperatureFreshAir2: "0245101f-fbd7-469d-85af-dbd0a52bcf3e",
        nantongStationHumidityFreshAir1: "50e3e61b-16d4-4533-984f-29d03692c6b0",
        nantongStationHumidityFreshAir2: "7c72ee46-cbf8-49ec-8c90-e620ff78d3b4",
        nantongStationHumidityVent: "9e521a38-a8ca-449b-9f27-7737a98ce45c",
        nantongStationTemperatureVent: "8973368b-2206-49b3-8585-428d285692cc",
        nantongStationRunning1: "420be4d3-84d8-4f55-a3ff-ae8101a0075d",
        nantongStationRunning2: "d8735d8e-294b-4131-8e08-c695c9ea42f9",
        nantongStationRunning3: "83512d72-b9eb-4e80-8ec6-1e015c1a983b",
        nantongStationRunning4: "ed320277-3b1f-43d5-b1c3-6c4fa7133311",
        nantongStationRunningFreshAir1: "345ec227-7bac-4dc5-8b3f-d228fb1fa8e6",
        nantongStationRunningFreshAir2: "1a7b5d19-e5bb-4ccd-9fb9-ac0be5ee2ed9",
        nantongHumidity1: "09f3ff98-a456-42a2-8173-2cb1540b2092",
        nantongHumidity2: "eaf26610-dd47-4cdf-894d-8e9fb723246e",
        nantongHumidity3: "6bb2f833-1168-4c99-a1aa-65c19c6074f6",
        nantongHumidity4: "d63ed269-c699-4004-a54d-2640b72476a8",
        nantongHumidity5: "c102ecc8-ddcf-487b-9782-2a924192ae97",
        nantongHumidity6: "4917a5ad-7229-4c6b-a2fb-b5f95c5e5954",
        nantongHumidity7: "19c02e94-72c1-4df8-a146-0cc863e3ede9",
        nantongHumidity8: "bd19c546-ba95-40d8-9bfa-2e28fd36e0d5",
        nantongHumidity9: "b4f9b98e-be49-45ce-9953-410fb92fc9d5",
        nantongTemperature1: "f8843c76-5830-4748-b2d2-3d2fb1931377",
        nantongTemperature2: "967b7509-d817-4539-8099-4ca8b24aaa5d",
        nantongTemperature3: "75661218-0d6d-4ca0-8056-fc620db472aa",
        nantongTemperature4: "e541524d-586f-4494-a673-4274bf1ca758",
        nantongTemperature5: "a00d5ef0-2f4b-498f-865c-6a93445b5b5a",
        nantongTemperature6: "bf6577b5-945d-49ce-94b5-a5ccdc3dfba7",
        nantongTemperature7: "6d69094d-f4f9-4c80-865f-b02397b688a4",
        nantongTemperature8: "74f992a5-3cab-4b28-8a3d-c05708cd1086",
        nantongTemperature9: "ee008e3e-d815-47df-864a-17cda1423b4d",

        changshuStationHumidity5: "d233111d-2aac-4bbd-8985-5172e3c099a1",
        changshuStationHumidity6: "dea05f81-6084-4880-92f7-a0b6e0add11e",
        changshuStationHumidity7: "9dead306-20b5-4264-a6cb-8bc56ad72adf",
        changshuStationHumidity8: "382847d7-9cc4-4a75-913b-886018d18ebe",
        changshuStationTemperature5: "de231ff9-13b0-4e14-a4b9-6dff47c7c8ed",
        changshuStationTemperature6: "78683393-721e-45d9-8e1c-3878d558463f",
        changshuStationTemperature7: "5b3d70f6-e926-419b-bc85-5e3730117a7b",
        changshuStationTemperature8: "41001d7c-1df9-484d-8dbf-e4024e752f7a",
        changshuStationHumidityFreshAir3: "db4f2a13-eda6-4d95-9259-17c320a7226f",
        changshuStationHumidityFreshAir4: "b0392268-96ff-403e-b4bc-f55185c33793",
        changshuStationTemperatureFreshAir3: "d9e5e703-6342-4beb-8818-112e65be5c85",
        changshuStationTemperatureFreshAir4: "4c851e58-e5ac-4dd4-96f7-2fb9583a33e1",
        changshuStationHumidityVent: "10874e62-9ffa-4126-bc22-8a87797d2b26",
        changshuStationTemperatureVent: "18d4c7b9-a4f0-4072-bf0e-5a1e4acc2406",
        changshuStationRunning5: "653ec3f5-feac-4544-9f9f-e34ba13a358c",
        changshuStationRunning6: "f8d972a3-66fa-4150-83fa-6b5f535b54e7",
        changshuStationRunning7: "ce25f022-240e-4d2e-9510-8fe813d3b9c9",
        changshuStationRunning8: "c9fadf32-7476-4a79-8f79-cdba2946b82d",
        changshuStationRunningFreshAir3: "3efd5861-de1f-403a-b18d-77d573b4f6bd",
        changshuStationRunningFreshAir4: "6d566683-1b2c-414e-a145-10e464f65315",
        changshuHumidity1: "4dc2ac4a-60a2-4328-b274-4842cacddfde",
        changshuHumidity2: "0cef46c6-3f2b-4db8-a515-08f5b657d2fd",
        changshuHumidity3: "c412904e-7e72-4831-8458-ba5b972ff4cd",
        changshuHumidity4: "00854ab6-469a-4d6e-8c1d-9d8737123a17",
        changshuHumidity5: "c235f6ba-bd52-4b66-8d42-e2d601ef2da6",
        changshuHumidity6: "18e59f08-6a03-42c3-942a-3b220b7386cc",
        changshuHumidity7: "636dd376-58c0-41bf-93c3-7d86bb278ca4",
        changshuHumidity8: "843034db-ac5b-45d0-a73a-e5e6f910d908",
        changshuHumidity9: "d03669e1-6a01-4cfc-87a4-782a8ce21649",
        changshuTemperature1: "b700a3a4-7128-4b6f-ada9-3af60a43737d",
        changshuTemperature2: "1595beee-1c57-4ded-ac3d-9b93f6d6aa39",
        changshuTemperature3: "d37f5511-7c9a-4acf-87ab-aef0c508e70f",
        changshuTemperature4: "a88681af-3d50-40ce-9d1a-e39b0576f402",
        changshuTemperature5: "e5315ead-5879-4072-b6c1-494b476565db",
        changshuTemperature6: "d2331e3f-a78f-418f-969a-28cac3ec3fb3",
        changshuTemperature7: "69e66ec7-ba90-486f-a203-810a1c51fbf4",
        changshuTemperature8: "41cd7939-1a54-4c9f-b609-bfbb1e89d98e",
        changshuTemperature9: "25da5428-b0fd-4061-ba7d-a75eb87e2360",

        nantongStationMalfunction1: "204725bc-30b7-4d7b-b249-303bd2f9244b",
        nantongStationMalfunction2: "3b29d453-cb70-47fa-a738-704ddc2494eb",
        nantongStationMalfunction3: "6e9de1ed-4f89-4362-9fc7-a0b184e012a5",
        nantongStationMalfunction4: "8ed2aefa-094e-473c-8ba5-75937831d588",
        nantongStationMalfunctionFreshAir1: "9d56b9e3-89e9-4a69-97a6-88a16d9d0d19",
        nantongStationMalfunctionFreshAir2: "f05480dc-4be1-44e0-aafb-a00df5144096",
        changshuStationMalfunction5: "493f5b40-1af9-4339-8e6a-4194e509deef",
        changshuStationMalfunction6: "656e004a-783a-4022-9b57-243378a8df6a",
        changshuStationMalfunction7: "e9886b9c-a9ed-476f-8385-e361a060ca14",
        changshuStationMalfunction8: "8b0139e4-bbe8-4686-89f3-05b3a0b1c54d",
        changshuStationMalfunctionFreshAir3: "64740814-48f8-47e1-9a72-0b843c3ca738",
        changshuStationMalfunctionFreshAir4: "4d88d0e5-8dee-4464-ae98-96269a8b1fc8",
      },
      allowedMaxNameIdDict: {
        nantongStationHumidityAllowedMax1: "549ea385-5f5b-42d1-925c-c53b5f946bec",
        nantongStationHumidityAllowedMax2: "dbeda865-2853-4d58-87b0-13272d851ed0",
        nantongStationHumidityAllowedMax3: "ef211fd0-77be-41b6-999f-2c3b0949a71e",
        nantongStationHumidityAllowedMax4: "7b843655-8f8b-4313-ba76-f37f0d0b639e",
        nantongStationHumidityAllowedMaxFreshAir1: "50e3e61b-16d4-4533-984f-29d03692c6b0",
        nantongStationHumidityAllowedMaxFreshAir2: "7c72ee46-cbf8-49ec-8c90-e620ff78d3b4",
        nantongStationHumidityAllowedMaxVent: "9e521a38-a8ca-449b-9f27-7737a98ce45c",
        nantongHumidityAllowedMax1: "09f3ff98-a456-42a2-8173-2cb1540b2092",
        nantongHumidityAllowedMax2: "eaf26610-dd47-4cdf-894d-8e9fb723246e",
        nantongHumidityAllowedMax3: "6bb2f833-1168-4c99-a1aa-65c19c6074f6",
        nantongHumidityAllowedMax4: "d63ed269-c699-4004-a54d-2640b72476a8",
        nantongHumidityAllowedMax5: "c102ecc8-ddcf-487b-9782-2a924192ae97",
        nantongHumidityAllowedMax6: "4917a5ad-7229-4c6b-a2fb-b5f95c5e5954",
        nantongHumidityAllowedMax7: "19c02e94-72c1-4df8-a146-0cc863e3ede9",
        nantongHumidityAllowedMax8: "bd19c546-ba95-40d8-9bfa-2e28fd36e0d5",
        nantongHumidityAllowedMax9: "b4f9b98e-be49-45ce-9953-410fb92fc9d5",
        changshuStationHumidityAllowedMax5: "d233111d-2aac-4bbd-8985-5172e3c099a1",
        changshuStationHumidityAllowedMax6: "dea05f81-6084-4880-92f7-a0b6e0add11e",
        changshuStationHumidityAllowedMax7: "9dead306-20b5-4264-a6cb-8bc56ad72adf",
        changshuStationHumidityAllowedMax8: "382847d7-9cc4-4a75-913b-886018d18ebe",
        changshuStationHumidityAllowedMaxFreshAir3: "db4f2a13-eda6-4d95-9259-17c320a7226f",
        changshuStationHumidityAllowedMaxFreshAir4: "b0392268-96ff-403e-b4bc-f55185c33793",
        changshuStationHumidityAllowedMaxVent: "10874e62-9ffa-4126-bc22-8a87797d2b26",
        changshuHumidityAllowedMax1: "4dc2ac4a-60a2-4328-b274-4842cacddfde",
        changshuHumidityAllowedMax2: "0cef46c6-3f2b-4db8-a515-08f5b657d2fd",
        changshuHumidityAllowedMax3: "c412904e-7e72-4831-8458-ba5b972ff4cd",
        changshuHumidityAllowedMax4: "00854ab6-469a-4d6e-8c1d-9d8737123a17",
        changshuHumidityAllowedMax5: "c235f6ba-bd52-4b66-8d42-e2d601ef2da6",
        changshuHumidityAllowedMax6: "18e59f08-6a03-42c3-942a-3b220b7386cc",
        changshuHumidityAllowedMax7: "636dd376-58c0-41bf-93c3-7d86bb278ca4",
        changshuHumidityAllowedMax8: "843034db-ac5b-45d0-a73a-e5e6f910d908",
        changshuHumidityAllowedMax9: "d03669e1-6a01-4cfc-87a4-782a8ce21649",
      },
      dataNameErrorNameDict: {
        nantongStationHumidity1: "nantongStationError12",
        nantongStationHumidity2: "nantongStationError12",
        nantongStationHumidity3: "nantongStationError34",
        nantongStationHumidity4: "nantongStationError34",
        nantongStationTemperature1: "nantongStationError12",
        nantongStationTemperature2: "nantongStationError12",
        nantongStationTemperature3: "nantongStationError34",
        nantongStationTemperature4: "nantongStationError34",
        nantongStationTemperatureFreshAir1: "nantongStationErrorFreshAir12",
        nantongStationTemperatureFreshAir2: "nantongStationErrorFreshAir12",
        nantongStationHumidityFreshAir1: "nantongStationErrorFreshAir12",
        nantongStationHumidityFreshAir2: "nantongStationErrorFreshAir12",
        nantongStationHumidityVent: "nantongStationErrorVent",
        nantongStationTemperatureVent: "nantongStationErrorVent",
        nantongStationRunning1: "nantongStationError12",
        nantongStationRunning2: "nantongStationError12",
        nantongStationRunning3: "nantongStationError34",
        nantongStationRunning4: "nantongStationError34",
        nantongStationRunningFreshAir1: "nantongStationErrorFreshAir12",
        nantongStationRunningFreshAir2: "nantongStationErrorFreshAir12",
        nantongHumidity1: "nantongError1",
        nantongHumidity2: "nantongError2",
        nantongHumidity3: "nantongError3",
        nantongHumidity4: "nantongError4",
        nantongHumidity5: "nantongError5",
        nantongHumidity6: "nantongError6",
        nantongHumidity7: "nantongError7",
        nantongHumidity8: "nantongError8",
        nantongHumidity9: "nantongError9",
        nantongTemperature1: "nantongError1",
        nantongTemperature2: "nantongError2",
        nantongTemperature3: "nantongError3",
        nantongTemperature4: "nantongError4",
        nantongTemperature5: "nantongError5",
        nantongTemperature6: "nantongError6",
        nantongTemperature7: "nantongError7",
        nantongTemperature8: "nantongError8",
        nantongTemperature9: "nantongError9",

        changshuStationHumidity5: "changshuStationError56",
        changshuStationHumidity6: "changshuStationError56",
        changshuStationHumidity7: "changshuStationError78",
        changshuStationHumidity8: "changshuStationError78",
        changshuStationTemperature5: "changshuStationError56",
        changshuStationTemperature6: "changshuStationError56",
        changshuStationTemperature7: "changshuStationError78",
        changshuStationTemperature8: "changshuStationError78",
        changshuStationHumidityFreshAir3: "changshuStationErrorFreshAir34",
        changshuStationHumidityFreshAir4: "changshuStationErrorFreshAir34",
        changshuStationTemperatureFreshAir3: "changshuStationErrorFreshAir34",
        changshuStationTemperatureFreshAir4: "changshuStationErrorFreshAir34",
        changshuStationHumidityVent: "changshuStationErrorVent",
        changshuStationTemperatureVent: "changshuStationErrorVent",
        changshuStationRunning5: "changshuStationError56",
        changshuStationRunning6: "changshuStationError56",
        changshuStationRunning7: "changshuStationError78",
        changshuStationRunning8: "changshuStationError78",
        changshuStationRunningFreshAir3: "changshuStationErrorFreshAir34",
        changshuStationRunningFreshAir4: "changshuStationErrorFreshAir34",
        changshuHumidity1: "changshuError1",
        changshuHumidity2: "changshuError2",
        changshuHumidity3: "changshuError3",
        changshuHumidity4: "changshuError4",
        changshuHumidity5: "changshuError5",
        changshuHumidity6: "changshuError6",
        changshuHumidity7: "changshuError7",
        changshuHumidity8: "changshuError8",
        changshuHumidity9: "changshuError9",
        changshuTemperature1: "changshuError1",
        changshuTemperature2: "changshuError2",
        changshuTemperature3: "changshuError3",
        changshuTemperature4: "changshuError4",
        changshuTemperature5: "changshuError5",
        changshuTemperature6: "changshuError6",
        changshuTemperature7: "changshuError7",
        changshuTemperature8: "changshuError8",
        changshuTemperature9: "changshuError9",
      },
      malfunctionDataNameErrorNameDict: {
        nantongStationMalfunction1: "nantongStationError12",
        nantongStationMalfunction2: "nantongStationError12",
        nantongStationMalfunction3: "nantongStationError34",
        nantongStationMalfunction4: "nantongStationError34",
        nantongStationMalfunctionFreshAir1: "nantongStationErrorFreshAir12",
        nantongStationMalfunctionFreshAir2: "nantongStationErrorFreshAir12",
        changshuStationMalfunction5: "changshuStationError56",
        changshuStationMalfunction6: "changshuStationError56",
        changshuStationMalfunction7: "changshuStationError78",
        changshuStationMalfunction8: "changshuStationError78",
        changshuStationMalfunctionFreshAir3: "changshuStationErrorFreshAir34",
        changshuStationMalfunctionFreshAir4: "changshuStationErrorFreshAir34",
      },
      dataNameTooltipErrorNameDict: {
        nantongStationHumidity1: "nantongStationHumidityTooltipError1",
        nantongStationHumidity2: "nantongStationHumidityTooltipError2",
        nantongStationHumidity3: "nantongStationHumidityTooltipError3",
        nantongStationHumidity4: "nantongStationHumidityTooltipError4",
        nantongStationHumidityFreshAir1: "nantongStationHumidityTooltipErrorFreshAir1",
        nantongStationHumidityFreshAir2: "nantongStationHumidityTooltipErrorFreshAir2",
        nantongStationHumidityVent: "nantongStationHumidityTooltipErrorVent",
        nantongHumidity1: "nantongHumidityTooltipError1",
        nantongHumidity2: "nantongHumidityTooltipError2",
        nantongHumidity3: "nantongHumidityTooltipError3",
        nantongHumidity4: "nantongHumidityTooltipError4",
        nantongHumidity5: "nantongHumidityTooltipError5",
        nantongHumidity6: "nantongHumidityTooltipError6",
        nantongHumidity7: "nantongHumidityTooltipError7",
        nantongHumidity8: "nantongHumidityTooltipError8",
        nantongHumidity9: "nantongHumidityTooltipError9",
        changshuStationHumidity5: "changshuStationHumidityTooltipError5",
        changshuStationHumidity6: "changshuStationHumidityTooltipError6",
        changshuStationHumidity7: "changshuStationHumidityTooltipError7",
        changshuStationHumidity8: "changshuStationHumidityTooltipError8",
        changshuStationHumidityFreshAir3: "changshuStationHumidityTooltipErrorFreshAir3",
        changshuStationHumidityFreshAir4: "changshuStationHumidityTooltipErrorFreshAir4",
        changshuStationHumidityVent: "changshuStationHumidityTooltipErrorVent",
        changshuHumidity1: "changshuHumidityTooltipError1",
        changshuHumidity2: "changshuHumidityTooltipError2",
        changshuHumidity3: "changshuHumidityTooltipError3",
        changshuHumidity4: "changshuHumidityTooltipError4",
        changshuHumidity5: "changshuHumidityTooltipError5",
        changshuHumidity6: "changshuHumidityTooltipError6",
        changshuHumidity7: "changshuHumidityTooltipError7",
        changshuHumidity8: "changshuHumidityTooltipError8",
        changshuHumidity9: "changshuHumidityTooltipError9",
      },
      // dataNameRunningTooltipNameDict: {
      //   nantongStationRunning1: "nantongStationRunningTooltip1",
      //   nantongStationRunning2: "nantongStationRunningTooltip2",
      //   nantongStationRunning3: "nantongStationRunningTooltip3",
      //   nantongStationRunning4: "nantongStationRunningTooltip4",
      //   nantongStationRunningFreshAir1: "nantongStationRunningTooltipFreshAir1",
      //   nantongStationRunningFreshAir2: "nantongStationRunningTooltipFreshAir2",

      //   changshuStationRunning5: "changshuStationRunningTooltip5",
      //   changshuStationRunning6: "changshuStationRunningTooltip6",
      //   changshuStationRunning7: "changshuStationRunningTooltip7",
      //   changshuStationRunning8: "changshuStationRunningTooltip8",
      //   changshuStationRunningFreshAir3: "changshuStationRunningTooltipFreshAir3",
      //   changshuStationRunningFreshAir4: "changshuStationRunningTooltipFreshAir4",
      // },
      dataNameRunningClassNameDict: {
        nantongStationRunning1: "nantongStationRunningClass1",
        nantongStationRunning2: "nantongStationRunningClass2",
        nantongStationRunning3: "nantongStationRunningClass3",
        nantongStationRunning4: "nantongStationRunningClass4",
        nantongStationRunningFreshAir1: "nantongStationRunningClassFreshAir1",
        nantongStationRunningFreshAir2: "nantongStationRunningClassFreshAir2",

        changshuStationRunning5: "changshuStationRunningClass5",
        changshuStationRunning6: "changshuStationRunningClass6",
        changshuStationRunning7: "changshuStationRunningClass7",
        changshuStationRunning8: "changshuStationRunningClass8",
        changshuStationRunningFreshAir3: "changshuStationRunningClassFreshAir3",
        changshuStationRunningFreshAir4: "changshuStationRunningClassFreshAir4",
      },
      stationIdList: [
        "5aacca32-8e87-4e7f-b981-33af6ec49fb1",
        "70e68586-3dd0-4da6-b293-6d724fb913e0",
        "865cb5cf-579e-4191-8b07-05898672cef7",
        "83027b7a-134e-4e0d-bb52-b34175efe63b",
        "018ca956-d3f9-4c42-8656-bf704c1d650a",
        "269d3d53-fc75-40f0-b445-ba2bd7a15d0e",
      ],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (runningFlag > 0) {
        result += ", 除湿机运行";
      } else if(runningFlag === 0) {
        result += ", 除湿机停止";
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}
.tooltip-slot {
  line-height: 1.4;
}
.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
 // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1030px;
        height: 320px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url("../../assets/image/sutong/bridgeLine.png");

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
          &-left {
            top: 248px;
            left: 240px;
          }
          &-right {
            top: 248px;
            left: 790px;
          }
        }
        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }
        .sta-left {
          top: 260px;
          left: 249px;
          &::before {
            top: 24px;
            left: -41px;
            transform: rotate(131deg);
          }
          &:after {
            top: 43px;
            left: -47px;
          }
          .state-info {
            right: 49px;
            top: 44px;
          }
        }
        .sta-right-nantong {
          top: 260px;
          right: 222px;
          &::before {
            top: 24px;
            left: -10px;
            transform: rotate(229deg);
          }
          &:after {
            top: 43px;
            left: 31px;
          }
          .state-info {
            right: -170px;
            top: 44px;
          }
        }
        .sta-right-changshu {
          top: 260px;
          right: 222px;
          &::before {
            top: 24px;
            left: -10px;
            transform: rotate(229deg);
          }
          &:after {
            top: 43px;
            left: 31px;
          }
          .state-info {
            right: -171px;
            top: 44px;
          }
        }
        .sta-right-fresh-air {
          top: 260px;
          right: 228px;
          &::before {
            top: 24px;
            left: -45px;
            transform: rotate(131deg);
          }
          &:after {
            top: 43px;
            left: -50px;
          }
          .state-info {
            right: 52px;
            top: 44px;
          }
        }
        .sta-left-fresh-air {
          top: 260px;
          left: 293px;
          &::before {
            top: 24px;
            left: -45px;
            transform: rotate(229deg);
          }
          &:after {
            top: 43px;
            left: -4px;
          }
          .state-info {
            left: 13px;
            top: 44px;
          }
        }
        .sta-left-vent {
          top: 260px;
          left: 293px;
          &::before {
            top: 24px;
            left: -45px;
            transform: rotate(229deg);
          }
          &:after {
            top: 43px;
            left: -4px;
          }
          .state-info {
            left: 13px;
            top: 44px;
          }
        }
        .sta-right-vent {
          top: 260px;
          right: 228px;
          &::before {
            top: 24px;
            left: -45px;
            transform: rotate(131deg);
          }
          &:after {
            top: 43px;
            left: -50px;
          }
          .state-info {
            right: 52px;
            top: 44px;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }
        .left1 {
          top: 250px;
          left: 100px;
          &::before {
            bottom: 35px;
            left: -63px;
            width: 90px;
            transform: rotate(48deg);
          }
          &::after {
            bottom: 68px;
            left: -62px;
          }
          .state-info {
            right: 80px;
            top: -53px;
          }
        }
        .left2 {
          top: 250px;
          left: 195px;
          &::before {
            bottom: 62px;
            left: -92px;
            width: 140px;
            transform: rotate(62deg);
          }
          &::after {
            bottom: 124px;
            left: -69px;
          }
          .state-info {
            right: 86px;
            top: -108px;
          }
        }
        .left3 {
          top: 250px;
          left: 295px;
          &::before {
            bottom: 95px;
            left: -114px;
            width: 190px;
            transform: rotate(72deg);
          }
          &::after {
            bottom: 185px;
            left: -62px;
          }
          .state-info {
            right: 80px;
            top: -170px;
          }
        }
        .left4 {
          top: 250px;
          left: 400px;
          &::before {
            bottom: 108px;
            left: -121px;
            width: 220px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 216px;
            left: -44px;
          }
          .state-info {
            right: 62px;
            top: -201px;
          }
        }
        .right1 {
          top: 250px;
          right: 80px;
          &::before {
            bottom: 40px;
            left: -10px;
            transform: rotate(132deg);
            width: 90px;
          }
          &::after {
            bottom: 73px;
            left: 64px;
          }
          .state-info {
            left: 80px;
            top: -58px;
          }
        }
        .right2 {
          top: 250px;
          right: 175px;
          &::before {
            bottom: 66px;
            left: -30px;
            transform: rotate(118deg);
            width: 140px;
          }
          &::after {
            bottom: 128px;
            left: 72px;
          }
          .state-info {
            left: 88px;
            top: -113px;
          }
        }
        .right3 {
          top: 250px;
          right: 270px;
          &::before {
            bottom: 94px;
            left: -58px;
            transform: rotate(108deg);
            width: 190px;
          }
          &::after {
            bottom: 185px;
            left: 65px;
          }
          .state-info {
            left: 82px;
            top: -170px;
          }
        }
        .right4 {
          top: 250px;
          right: 370px;
          &::before {
            bottom: 112px;
            left: -83px;
            transform: rotate(100deg);
            width: 220px;
          }
          &::after {
            bottom: 220px;
            left: 46px;
          }
          .state-info {
            left: 63px;
            top: -205px;
          }
        }
        .middle-left {
          top: 249px;
          left: 530px;
          &::before {
            bottom: -16px;
            left: -39px;
            width: 60px;
            transform: rotate(300deg);
          }
          &::after {
            bottom: -42px;
            left: -38px;
          }
          .state-info {
            right: 54px;
            top: 56px;
          }
        }
        .middle-right {
          top: 249px;
          left: 530px;
          &::before {
            bottom: -16px;
            left: -5px;
            width: 60px;
            transform: rotate(240deg);
          }
          &::after {
            bottom: -42px;
            left: 39px;
          }
          .state-info {
            right: -114px;
            top: 57px;
          }
        }
      }
    }
  }
}
</style>